<template>
  <div class="record-wrapper">
    <div v-if="recording" class="record-button" v-bind:class="{ enabled: hasPlayed && seeking == false }" v-on:click="toggleRecording">
      Recording HiLite
    </div>
    <div v-else class="record-button" v-bind:class="{ enabled: hasPlayed && seeking == false }" v-on:click="toggleRecording">
      Record HiLite
    </div>
  </div>
</template>

<script>
export default {
  name: "RecordButton",
  props: ["player", "isPlaying"],
  data() {
    return {
      recordedSegments: [],
      edgeSegments: []
    };
  },
  computed: {
    recording: {
      get() {
        return this.player.recording;
      },
      set(value) {
        this.player.recording = value;
      }
    },
    hasPlayed: {
      get() {
        return this.$store.state.player.hasPlayed;
      }
    },
    seeking: {
      get() {
        return this.$store.state.player.seeking;
      }
    }
  },
  methods: {
    toggleRecording() {
      if (this.hasPlayed) {
        this.recording = !this.recording;
      }
    },
    onRecordingEnd() {
      this.toggleRecording();
    }
  },
  watch: {
    recording: {
      handler(isRecording) {
        const videoJSPlayer = this.$parent.$refs.videoJSComponent.videoJSPlayer;

        if (isRecording) {
          if (videoJSPlayer.paused()) {
            videoJSPlayer.play();
          }

          videoJSPlayer.trigger(
            "recordSegments",
            this.recordedSegments,
          );

          videoJSPlayer.one("ended", this.onRecordingEnd);

        } else {
          videoJSPlayer.trigger(
            "stopRecordingSegments",
            this.edgeSegments
          );

          let newManifestObj = videoJSPlayer.tech().hls.playlists.media();

          videoJSPlayer.one("ended", this.onRecordingEnd);

          newManifestObj = JSON.parse(JSON.stringify(newManifestObj));
          newManifestObj.segments = this.recordedSegments;
          newManifestObj.edgeSegments = this.edgeSegments;

          this.$store.commit("setEditor", newManifestObj);
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.record-wrapper
  text-align: center
  margin-top: 25px
  position: relative
  @media screen and (max-width: mobile-landscape)
    display: none
  &:before, &:after
    content: ""
    width: calc(50% - 120px)
    position: absolute
    top: 0px
    bottom: 0px
    margin: auto
    height: 1px
  &:before
    left: 0px
    background: linear-gradient(to right, #ffffff 0%,#d1d1d1 100%);
  &:after {
    right: 0px
    background: linear-gradient(to left, #ffffff 0%,#d1d1d1 100%);
  }
  .record-button
    position: relative
    line-height: 45px
    font-weight: bold
    padding: 5px 20px 5px 60px
    border: 1px solid #D1D1D1
    border-radius: 5px
    display: inline-block
    fluid font-size 16 14
    cursor: pointer
    opacity: 0.2
    transition: opacity 350ms
    &.enabled
      opacity: 1
      &:hover
        background: linear-gradient(to bottom, #ffffff 0%,#EFEFEF 100%);
        &:active
          background: linear-gradient(to bottom, #EFEFEF 0%,#ffffff 100%);
    &:before
      content: ""
      position: absolute
      width: 30px
      height: 30px
      left: 20px
      top: 0px
      bottom: 0px
      margin: auto
      border-radius: 50%
      background: linear-gradient(to bottom, #c81818 0%,#b61010 100%);
</style>
